import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsConnect from "./sections/LetsConnect";
import ReserveYourExperience from "./sections/ReserveYourExperience";
import OurGlobalKitchen from "./sections/OurGlobalKitchen";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsConnect />
      <ReserveYourExperience />
      <OurGlobalKitchen />
      <Footer />
    </div>;
}